
(() => {
    window.truncate = function () {
        $('.js-truncate').each(function () {
            let e = $(this);
            let parentHeight = e.parent().innerHeight();
            if (parentHeight <= 0) return;
            while (e.innerHeight() > parentHeight && e.text()) {
                let lastSpace = e.text().lastIndexOf(' ');
                if (lastSpace > 0) {
                    e.text(e.text().substring(0, lastSpace) + "...");
                } else {
                    e.text("");
                }
                //console.log(e.text());
            }
        });
    }

    $(document).ready(() => {
        window.truncate();
    });
})();